// extracted by mini-css-extract-plugin
export var activeFilterButton = "_od-c";
export var backButton = "_od-4";
export var backIcon = "_od-5";
export var chevronShortcut = "_od-6";
export var container = "_od-1";
export var editor = "_od-8";
export var editorWrapper = "_od-7";
export var prefix = "_od-2";
export var searchIcon = "_od-3";
export var suffix = "_od-9";
export var suffixContent = "_od-a";
export var suffixText = "_od-b";
export var wrapper = "_od-0";